import {
  useGetCartQuery,
  useLazyGetCartQuery,
} from "@/rtkQuery/features/services/cartDrawer/cartApi.slice";
import { useAuthService } from "@/rtkQuery/features/hooks";

export const useCartService = () => {
  const { isAuthenticated } = useAuthService();

  const { data, error, isLoading, isError, isSuccess, refetch, status } =
    useGetCartQuery(undefined, {
      skip: !isAuthenticated,
    });

  const [
    trigger,
    {
      data: lazyData,
      error: lazyError,
      isLoading: lazyLoading,
      isSuccess: lazySuccess,
      isError: lazyFail,
      status: lazyStatus,
    },
  ] = useLazyGetCartQuery();

  const extractErrorMessage = (err: unknown): string => {
    if (err && typeof err === "object") {
      const anyErr = err as any;
      return (
        anyErr?.meta?.error ||
        anyErr?.data?.message ||
        anyErr?.error ||
        "Something went wrong"
      );
    }
    return "Something went wrong";
  };

  const shouldShowLoading = isAuthenticated && (isLoading || status === 'pending');

  const cartCount = isAuthenticated && data && data.products?.length > 0
    ? (data?.products?.length || 0)
    : 0;

  return {
    cartData: data ?? null,
    cartDataLength: cartCount,
    cartIsLoading: shouldShowLoading,
    cartIsError: !!isError,
    cartIsSuccess: !!isSuccess,
    cartError: error ?? null,
    cartErrorMessage: extractErrorMessage(error),
    cartRefetch: typeof refetch === "function" ? refetch : () => { },
    cartStatus: status ?? "uninitialized",

    fetchCart: () => trigger(undefined, true),
    cartLazyData: lazyData ?? null,
    cartLazyError: lazyError ?? null,
    cartLazyIsLoading: !!lazyLoading,
    cartLazyIsSuccess: !!lazySuccess,
    cartLazyIsError: !!lazyFail,
    cartLazyStatus: lazyStatus ?? "uninitialized",
    cartLazyErrorMessage: extractErrorMessage(lazyError),
  };
};